import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  name: string;
  playerIds?: number[];
  doubles?: boolean;
}

// Profil zawodnika żyje pod Player.id. Zapisana para bywa jednym bytem z jednym id
// i nazwą złożoną z dwóch osób (ligi z ingestu) — wtedy linkuje się całość, bo nie
// ma czego rozdzielić. Gdy id jest tyle co członów nazwy, każda osoba dostaje swój.
export const ScoringPlayerLink: React.FC<Props> = ({ name, playerIds = [], doubles = false }) => {
  const suffix = doubles ? '?tab=debel' : '';
  const parts = name.split(' / ');

  if (playerIds.length === parts.length) {
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={playerIds[index]}>
            {index > 0 && ' / '}
            <Link
              to={`/player/${playerIds[index]}${suffix}`}
              className="scoring-player-link"
              data-testid={`scoring-player-link-${playerIds[index]}`}
              onClick={(event) => event.stopPropagation()}
            >
              {part}
            </Link>
          </React.Fragment>
        ))}
      </>
    );
  }

  if (playerIds.length === 1) {
    return (
      <Link
        to={`/player/${playerIds[0]}${suffix}`}
        className="scoring-player-link"
        data-testid={`scoring-player-link-${playerIds[0]}`}
        onClick={(event) => event.stopPropagation()}
      >
        {name}
      </Link>
    );
  }

  return <>{name}</>;
};

export default ScoringPlayerLink;
